
import { Cookies } from 'react-cookie';
import { all, call, fork, takeEvery } from 'redux-saga/effects';

import { LOGOUT_USER } from './constants';

/**
 * Sets the session
 * @param {*} user
 */
const setSession = (user, tokens = null) => {
    let cookies = new Cookies();
    if (user) {
        cookies.set('user', JSON.stringify(user), { path: '/' });
        cookies.set('tokens', JSON.stringify(tokens), { path: '/' });
    } else {
        cookies.remove('user', { path: '/' });
        cookies.remove('tokens', { path: '/' });
    }
};

/**
 * Logout the user
 * @param {*} param0
 */
function* logout({ payload: { navigate } }) {
    try {
        setSession(null);
        yield call(() => {
            navigate('/account/login');
        });
    } catch (error) {}
}

export function* watchUserLogout() {
    yield takeEvery(LOGOUT_USER, logout);
}

function* authSaga() {
    yield all([fork(watchUserLogout)]);
}

export default authSaga;
